import { render, staticRenderFns } from "./payment-received.vue?vue&type=template&id=0877cd5f&"
import script from "./payment-received.js?vue&type=script&lang=js&"
export * from "./payment-received.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports